let value = null
try {
  if (localStorage.value) {
    value = localStorage.value
  }
} catch (e) {}

export default {
  value: value
}



// WEBPACK FOOTER //
// ./src/store/state.js